import {
  useNormalizer,
  useDate,
} from '@sttedra_ui/framework';

const {getString, getDate} = useNormalizer();
const {toISOStringWithTimezone} = useDate();

class RegisterUserViewModel {
  // #region Props
  identification;

  birthDate;
  email;
  name;
  phone;
  secondSurname;
  surname;

  identificationValidityDate;
  supportNumber;
  // #endregion

  constructor(registerData) {
    // (!) Always at the beginning
    this.identification = this.getStringToUpperCase(registerData?.identificationNumber);

    this.birthDate = this.getDateTimeStamp(registerData?.birthDate);
    this.email = getString(registerData?.email);
    this.name = this.getStringToUpperCase(registerData?.name);
    this.phone = this.getPhone(registerData?.phone);
    this.secondSurname = this.getStringToUpperCase(registerData?.secondSurname);
    this.surname = this.getStringToUpperCase(registerData?.surname);

    // (!) Always at the end
    this.supportNumber = this.getSupportNumber(registerData?.supportNumber);
    this.identificationValidityDate =
    this.getIdentificationValidityDate(registerData?.validDateDNI);
  }

  isNie() {
    return this.identification?.charAt(0).toUpperCase() === 'X' ||
      this.identification?.charAt(0).toUpperCase() === 'Y' ||
      this.identification?.charAt(0).toUpperCase() === 'Z';
  }

  isDni() {
    return !this.isNie() && this.identification;
  }

  getSupportNumber(value) {
    if (!getString(value) || !this.isNie(value)) return null;
    const letter = value.charAt(0).toUpperCase();
    const numValue = value.substr(1).padStart(8, '0');
    return String(letter + numValue);
  }

  getIdentificationValidityDate(value) {
    if (!this.getDateTimeStamp(value)) return null;
    return value && !this.isNie(value) ? this.getDateTimeStamp(value) : null;
  }

  getStringToUpperCase(value) {
    if (!getString(value)) return null;
    return value.toUpperCase();
  }

  getPhone(value) {
    if (!getString(value)) return null;
    return value.replace(/ /g, '');
  }

  getDateTimeStamp(value) {
    if (getString(value)) {
      // Convert the input string into a list of components
      const dateComponents = value.split('/');
      // Create a new date with the components
      const date = new Date(dateComponents[2], dateComponents[1] - 1, dateComponents[0]);

      // Convert the date to ISO format and remove the time part
      const stringTimeZone = toISOStringWithTimezone(date);
      if (!stringTimeZone) return null;
      return stringTimeZone.replace(/[-+]\d{2}:\d{2}$/, '');
    }

    if (getDate(value)) {
      const stringTimeZone = toISOStringWithTimezone(value);
      const date = new Date(stringTimeZone);
      date.setHours(0, 0, 0, 0);

      const stringTimeZone2 = toISOStringWithTimezone(date);
      if (!stringTimeZone2) return null;
      return stringTimeZone2.replace(/[-+]\d{2}:\d{2}$/, '');
    }
  }
}

export default RegisterUserViewModel;
